import { Alert, Button, Card, CardContent, CircularProgress } from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";

import { cadastrarAdicionarAlunoTurma } from "API/apiAcoes";
import CadastroProfissionaisForm from "components/molecules/CadastroProfissionaisForm/CadastroProfissionaisForm";
import CadastroUsuarioForm from "components/molecules/CadastroUsuarioForm/CadastroUsuarioForm";
import ContatoForm from "components/molecules/ContatoForm/ContatoForm";
import EnderecoForm from "components/molecules/EnderecoForm/EnderecoForm";
import PessoalForm from "components/molecules/PessoalForm/PessoalForm";
import { CadastroPayload, CadastroProvider, useCadastro } from "resources/CadastroProvider";

import styles from "./Turmas.module.css";
import styles_button from "../../../styles/Button.module.css";

const CadastroParticipanteTurmaContent = () => {
  const { activeStepIndex, steps, loadingRegister } = useCadastro();

  const stepComponents = [
    <CadastroUsuarioForm key="usuario" />,
    <PessoalForm key="pessoal" />,
    <ContatoForm key="contato" />,
    <EnderecoForm key="endereco" />,
    <CadastroProfissionaisForm key="profissionais" />,
  ];

  return (
    <div className={styles.cadastroParticipanteBox}>
      <div className={styles.cadastroParticipanteSteps}>
        {steps.map((step, index) => (
          <span
            key={step.label}
            className={index === activeStepIndex ? styles.cadastroParticipanteStepActive : styles.cadastroParticipanteStep}
          >
            {index + 1}
          </span>
        ))}
      </div>

      {stepComponents[activeStepIndex]}

      {loadingRegister && (
        <div className={styles.processamentoResultadosOverlay}>
          <CircularProgress />
          <span>Finalizando cadastro e matrícula...</span>
        </div>
      )}
    </div>
  );
};

const CadastroParticipanteTurma = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const turmaId = searchParams.get("turma") || "";

  const voltarControlePresenca = () => {
    navigate(turmaId ? `/controle-presenca?turma=${turmaId}` : "/controle-presenca");
  };

  const handleSubmitCadastro = async (payload: CadastroPayload) => {
    if (!turmaId) {
      throw new Error("Turma não informada.");
    }

    await cadastrarAdicionarAlunoTurma(turmaId, payload);
  };

  return (
    <Card className={styles.container}>
      <CardContent>
        <div className={styles.cadastroParticipanteHeader}>
          <div>
            <div className={styles.title}>Cadastrar novo participante</div>
            <p className={styles.cadastroParticipanteSubtitle}>
              Preencha as etapas do cadastro para criar o usuário e matriculá-lo na turma.
            </p>
          </div>

          <Button
            variant="contained"
            onClick={voltarControlePresenca}
            className={styles_button.buttonSecondary}
          >
            Voltar
          </Button>
        </div>

        {!turmaId ? (
          <Alert severity="error">Turma não informada para matrícula do participante.</Alert>
        ) : (
          <CadastroProvider
            basePath={null}
            onBackStart={voltarControlePresenca}
            onRegisterSubmit={handleSubmitCadastro}
            onRegisterSuccess={voltarControlePresenca}
          >
            <CadastroParticipanteTurmaContent />
          </CadastroProvider>
        )}
      </CardContent>
    </Card>
  );
};

export default CadastroParticipanteTurma;
